export default __webpack_public_path__ + "static/napa-d4df46428a276c6f22ccc40d5bcbec6c.jpg";